module.exports = __webpack_public_path__ + "assets/img/mtTitle-2d57bf36.png";